import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getRejectionBucketingFilter } from '@iotv/core-services';
import { DeviceClassName, Device as DeviceObject, DeviceState, isValidDeviceObject, } from '@iotv/datamodel-core';
import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SteppingLoadingModal } from '../../../Popup/Loading';
import { Severity } from '../../../types/AppTypes';
import { addToDevicesInventory } from '../../SytemManagement/sharedFns/addMultipleDevices';
import { defaultRowToObject } from '../../io/GoogleV2Hooks';
import { SimpleIOModal } from '../../io/VOBbased/SimpleIOModal';
import { IOType } from '../../io/types';
/** import sheet headers = type	eui	deviceId	deviceType	networkKey	appKey	name	description	id */
const euiRegex = /^(?:[0-9a-fA-F]{2}){8,}$/;
const isValidEui = (str) => !!(str && euiRegex.test(str));
const DeviceImportCard = (props) => {
    const { contextCustomer, user, userFunctions } = props;
    const [addState, setAddState] = useState(0);
    const [max, setMax] = useState(undefined);
    useEffect(() => {
        if (max && addState === max) {
            setMax(undefined);
            setAddState(0);
        }
    }, [addState]);
    const displayMessage = (content, type, severity) => {
        userFunctions.setUserMessage({ id: uuidv4(), content, label: content, type, severity });
    };
    const devicesImportFn = async (devices) => {
        const devicesAsObject = devices.map((vbo) => new DeviceObject(vbo));
        if (user && contextCustomer) {
            setMax(devicesAsObject.length);
            const addDevicesRes = await addToDevicesInventory({
                user: user,
                contextCustomer: contextCustomer,
                devices: devicesAsObject,
                progress: setAddState,
            });
            if (addDevicesRes.err) {
                displayMessage(addDevicesRes.err.message, 'MessageBar', Severity.error);
            }
            else {
                addDevicesRes.data && displayMessage(addDevicesRes.data, 'SnackBar', Severity.info);
            }
            // navigate(-1);
            // navigate(0);
        }
    };
    const setPlainObjectsInParent = (commonObjects) => {
        const euiRejectedItems = [];
        const euiRejectionBucketFilter = getRejectionBucketingFilter({
            filter: (item) => isValidEui(item.eui),
            rejectionsBucket: euiRejectedItems,
        });
        const requiredAttributeRejectedItems = [];
        const validBusinessObjectRejectionBucketFilter = getRejectionBucketingFilter({
            filter: isValidDeviceObject,
            rejectionsBucket: requiredAttributeRejectedItems,
        });
        const validDevices = commonObjects.filter(euiRejectionBucketFilter).filter(validBusinessObjectRejectionBucketFilter);
        if (euiRejectedItems.length > 0) {
            const message = `The following items have invalid euis which must be 16 byte hexadecimal strings ${euiRejectedItems.map((item) => item.eui).join(',')} `;
            displayMessage(message, 'MessageBar', Severity.warning);
        }
        if (requiredAttributeRejectedItems.length > 0) {
            const message = `${requiredAttributeRejectedItems.length} items were rejected as failed validation on one of: eui, appKey, networkKey, state, deviceId, deviceType. No items were imported`;
            displayMessage(message, 'MessageBar', Severity.warning);
        }
        else {
            devicesImportFn(validDevices);
        }
    };
    const rowToObjectFunction = (columnIndexedKeys, row, rowIndex) => {
        const baseObject = defaultRowToObject(columnIndexedKeys, row, rowIndex);
        baseObject.type = DeviceClassName;
        baseObject.state = DeviceState.MANUFACTURING;
        const { eui } = baseObject;
        if (typeof eui === 'string') {
            const EUI = eui.toUpperCase();
            if (isValidEui(EUI)) {
                const key = `Device:${EUI}`;
                Object.assign(baseObject, { sk: key, pk: key, id: EUI, eui: EUI });
            }
            else {
            }
        }
        return baseObject;
    };
    return (_jsxs(Stack, { direction: 'column', children: [_jsx(Stack, { direction: 'row', children: _jsx(SimpleIOModal, { allowIOTypeToggle: false,
                    initialIOType: IOType.IMPORT,
                    plainObjects: [],
                    setPlainObjectsInParent,
                    rowToObjectFunction,
                    sheets: [{ sheetName: 'Devices', headers: ['eui', 'deviceId', 'deviceType', 'networkKey', 'appKey', 'name', 'description', 'id'] }] }) }), _jsx(Stack, { direction: 'row', children: max && _jsx(SteppingLoadingModal, { current: addState, max: max }) })] }));
};
export default DeviceImportCard;
